// Reports a page view to /api/track on load and when the in-app route (hash) changes. Admin views are ignored server-side.
(function () {
  let last = '';
  function send() {
    if (!window.Consent || !window.Consent.has('analytics')) return; // counted only with the visitor's consent
    const path = '/' + location.hash.replace(/^#\/?/, '');
    if (path === last) return;
    last = path;
    let token = '';
    try { token = localStorage.getItem('wb_token') || ''; } catch (e) { /* no storage */ }
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch('/api/track', { method: 'POST', headers, body: JSON.stringify({ path }), keepalive: true }).catch(() => {});
  }
  send();
  window.addEventListener('hashchange', send);
  window.addEventListener('wb-consent', () => { last = ''; send(); });
})();
